import React from "react";

import {
  MissionNameCellStyled,
  VehicleFieldBodyStyled,
  VehicleNameStyled,
  VehicleTypeImgStyled,
} from "Components/LiveMissionsTable/styles";
import { EMPTY_ICON } from "Utils";
import { VehicleIcon } from "../MapComponent/components/VehicleIcon";

export const parseTime = (inputDateString: string | null | undefined) => {
  // Handle null, undefined, or empty strings
  if (!inputDateString) {
    return "N/A";
  }

  const parsedDate = new Date(inputDateString);

  // Check if the date is valid
  if (isNaN(parsedDate.getTime())) {
    return "N/A";
  }

  // Format the date and time in the desired output format
  const timeString = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(parsedDate);

  const dateString = new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
  }).format(parsedDate);

  return `${dateString} ${timeString}`;
};

export const getMissionNameField = (
  missionName: string,
  missionId: string,
  handleClick: (missionId: string) => void
) => {
  return (
    <MissionNameCellStyled
      data-test-id={`click-mission-name-${missionId}`}
      onClick={() => handleClick(missionId)}
    >
      {missionName}
    </MissionNameCellStyled>
  );
};

export const getAssignedToField = (
  vehicleId: string,
  vehicles: Vehicle[],
  vehicleTypes: VehicleType[],
  vehicleStates: VehiclesStateDataItem | null
) => {
  const vehicle = vehicles.find((vehicle) => vehicle?.id === vehicleId);
  const vehicleType = vehicleTypes.find(
    (vehicleType) => vehicleType.id === vehicle?.vehicleTypeId
  );
  const vehicleState = vehicleStates?.[vehicleId];

  return (
    <VehicleFieldBodyStyled>
      <VehicleIcon
        vbStatus={vehicleState?.t_virtual_bumper_status ?? ""}
        webstate={vehicleState?.t_web_status ?? ""}
        onlineStatus={vehicleState?.online_status ?? ""}
      />
      <VehicleTypeImgStyled src={vehicleType?.image?.link || EMPTY_ICON} />
      <VehicleNameStyled>{vehicle?.name ?? "NONE"}</VehicleNameStyled>
    </VehicleFieldBodyStyled>
  );
};
